import { Modal } from '../settings/Modal'
import styles from './MessageTextSelection.module.css'

/** Native selection lives outside the row, so holding text cannot reopen its actions. */
export function MessageTextSelection({ text, onClose }: { text: string; onClose: () => void }) {
  return (
    <Modal title="Выделить текст" onClose={onClose}>
      <div className={styles.text} tabIndex={0}>{text}</div>
    </Modal>
  )
}
